import { render, staticRenderFns } from "./RequestUserAccountPage.vue?vue&type=template&id=1b69a24e&scoped=true"
import script from "./RequestUserAccountPage.vue?vue&type=script&lang=ts"
export * from "./RequestUserAccountPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b69a24e",
  null
  
)

export default component.exports